import { useStopwatch } from 'hooks/useStopWatch';
import { CronoCallUI, CronoCallUIProps } from './CronoCallUI';
import { OpenState } from './hooks/cronoCallReducer';

export const OpenCallUI = ({
  callState,
  callStatusText,
  ...props
}: {
  callState: OpenState;
} & CronoCallUIProps) => {
  const { formattedTime } = useStopwatch({
    initialDate: callState.callStart,
    showHours: false,
  });

  return (
    <CronoCallUI
      {...props}
      callStatusText={formattedTime ?? callStatusText}
      callState={callState}
    />
  );
};
